<template>
  <flex-column class="wrapper">
    <flex-header>
      <div class="header">
        <flex-row gap center>
          <flex-cell>
            <h3>{{ title }}</h3>
            <div class="font-sm font-muted" v-if="description?.length">
              {{ description }}
            </div>
          </flex-cell>
          <!-- <flex-cell shrink> -->
          <!-- <ux-button color="primary" size="sm" @click="done">Save</ux-button> -->
          <!-- </flex-cell> -->
        </flex-row>
      </div>
    </flex-header>
    <flex-body>
      <ux-panel-body>
        <tagger v-model="options.model" />
      </ux-panel-body>
    </flex-body>
    <flex-footer>
      <div class="footer">
        <flex-row gap center>
          <flex-cell shrink>
            <ux-button @click="cancel">Cancel</ux-button>
          </flex-cell>
          <flex-cell />
          <flex-cell shrink>
            <ux-button color="primary" @click="done">Save</ux-button>
          </flex-cell>
        </flex-row>
      </div>
    </flex-footer>
  </flex-column>
</template>
<script>
import ModalMixin from "./ModalMixin.js";
import Tagger from "../ui/tagger.vue";

export default {
  mixins: [ModalMixin],
  components: {
    Tagger,
  },
  methods: {
    done() {
      this.close(this.options.model);
    },
    cancel() {
      this.dismiss();
    },
  },
  computed: {
    title() {
      return this.options.title || "Manage Tags";
    },
    description() {
      return this.options.description;
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
h3 {
  margin: 0;
}
.wrapper {
  min-width: 250px;
  max-width: 400px;
  width: 100%;
  border-radius: 0.5em;
  overflow: hidden;
}

.header {
  background: var(--bg1, #fff);
  padding: 0.5em 1em;
  border-bottom: 1px solid color-mix(in lab, currentColor 10%, var(--bg1));
}

.footer {
  background: var(--bg1, #fff);
  padding: 0.5em 1em;
  border-top: 1px solid color-mix(in lab, currentColor 10%, var(--bg1));
}
</style>
